__turbopack_context__.v({
  "afterDemo": "home-conversion-module__Qt5z5W__afterDemo",
  "bookChoices": "home-conversion-module__Qt5z5W__bookChoices",
  "demoCard": "home-conversion-module__Qt5z5W__demoCard",
  "demoLayout": "home-conversion-module__Qt5z5W__demoLayout",
  "demoNext": "home-conversion-module__Qt5z5W__demoNext",
  "demoResult": "home-conversion-module__Qt5z5W__demoResult",
  "demoSection": "home-conversion-module__Qt5z5W__demoSection",
  "market": "home-conversion-module__Qt5z5W__market",
  "nextStep": "home-conversion-module__Qt5z5W__nextStep",
  "note": "home-conversion-module__Qt5z5W__note",
  "returnRow": "home-conversion-module__Qt5z5W__returnRow",
  "section": "home-conversion-module__Qt5z5W__section",
  "steps": "home-conversion-module__Qt5z5W__steps",
  "textLink": "home-conversion-module__Qt5z5W__textLink",
  "title": "home-conversion-module__Qt5z5W__title",
});
